import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@environments/environment';
import { LogsService } from '@services/logs';
import { appConfig } from 'src/app/app.config';

import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => LogsService.fatal('main', 'Bootstrap failed', err));
